import _assign from "object-assign";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import deepmerge from 'deepmerge';
export var iconSizes = {
  small: 'small',
  medium: 'medium',
  large: 'large'
};
var iconSizeRamp = {
  small: 12,
  medium: 24,
  large: 48
};
export var sizeRamp = {
  touch: {
    s100: 44,
    s200: 60
  },
  low: {
    s100: 36,
    s200: 48
  },
  medium: {
    s100: 28,
    s200: 36
  },
  high: {
    s100: 20,
    s200: 24
  }
};
export var defaultSize = {
  regular: {
    touch: {
      height: sizeRamp.touch.s100
    },
    low: {
      height: sizeRamp.low.s100
    },
    medium: {
      height: sizeRamp.medium.s100
    },
    high: {
      height: sizeRamp.high.s100
    }
  },
  stackable: {
    touch: {
      height: sizeRamp.touch.s200
    },
    low: {
      height: sizeRamp.low.s200
    },
    medium: {
      height: sizeRamp.medium.s200
    },
    high: {
      height: sizeRamp.high.s200
    }
  },
  icon: {
    small: {
      height: iconSizeRamp.small,
      width: iconSizeRamp.small
    },
    medium: {
      height: iconSizeRamp.medium,
      width: iconSizeRamp.medium
    },
    large: {
      height: iconSizeRamp.large,
      width: iconSizeRamp.large
    }
  }
};

var createGetSize = function createGetSize(options) {
  return function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$variant = _ref.variant,
        variant = _ref$variant === void 0 ? 'regular' : _ref$variant,
        _ref$density = _ref.density,
        density = _ref$density === void 0 ? 'medium' : _ref$density,
        _ref$iconSize = _ref.iconSize,
        iconSize = _ref$iconSize === void 0 ? 'small' : _ref$iconSize;

    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var size = variant === 'icon' ? iconSize : density;

    if (!hasOwnProperty.call(options, variant) || !hasOwnProperty.call(options[variant], size)) {
      return {};
    }

    return options[variant][size];
  };
};

export var createSize = function createSize() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref2 = typeof size === 'function' ? size(sizeRamp) : size,
      otherGetSize = _ref2.getSize,
      otherOptions = _objectWithoutProperties(_ref2, ["getSize"]);

  var mergedOptions = deepmerge(defaultSize, otherOptions, {
    clone: false
  });
  return _assign({
    getSize: otherGetSize || createGetSize(mergedOptions),
    iconSizes: iconSizes
  }, mergedOptions);
};